<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
      <b-form-input type="text" v-model="name" required  :pattern=fullNamePattern minlength="2" maxlength="100" />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>Email <span class="text-danger">*</span></template>
      <b-form-input type="email" v-model.trim="email" required maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("phoneNumber") }}</template>
      <b-form-input type="tel" v-model="phone" :pattern="phonePattern" maxlength="50"
                    @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                    @input.native="$event.target.setCustomValidity('')" />
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as meetingService from "@/service/meetingService";
  import * as validationUtils from "@/service/validationUtils";

  @Component
  export default class UpdateMeetingParticipantModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;
    @Prop({ required: true }) meetingParticipant: any;
    @Emit("submitted") __submitted() {}

    name = "";
    email = "";
    phone = "";

    formErrorMsg = "";
    isSubmitting = false;




    mounted() {
      // Copy props from original object
      this.name = this.meetingParticipant.name;
      this.email = this.meetingParticipant.email;
      this.phone = this.meetingParticipant.phone;
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = "";
      this.name = this.name.trim();
      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg = this.$t("invalidEmail").toString();
        return;
      }

      const data = {
        id: this.meetingParticipant.id,
        name: this.name,
        email: this.email,
        phone: this.phone,
        role: this.meetingParticipant.role,
        assignedBy: this.meetingParticipant.assignedBy,
      };

      try {
        this.isSubmitting = true;
        await meetingService.updateParticipant(data);

        this.__submitted();
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.$bvModal.hide(this.modalId);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
